// extracted by mini-css-extract-plugin
export default {"link":"ChatGPTTests_link__1-I9q"};